<template>
  <div class="personal-view">
    <div class="menu">
      <menu-list></menu-list>
    </div>
    <div class="content">
      <!-- <div class="left-nav">
        <sidebar-two :title="sidebarTwoTitle" :list="sidebarTwoList" @selectMenu="selectMenu"></sidebar-two>
      </div> -->
      <div class="right-middle">
        <nav-menu
         :navMenuList="navMenuList"
         @handleSelect="handleSelect"
         :activeIndex="activeIndex"></nav-menu>
        <!-- <div class="xm">
          <div class="xmImg">
            今日限免
          </div>
          <ul class="data-view">
            <li v-for="(item, index) in dataList" :key="index">
              <div class="left">
                <img :src="item.imgUrl" alt="">
              </div>
              <div class="right">
                <p class="p-name">
                  {{item.name}}
                </p>
                <p class="p-money">
                  ￥{{item.money}}
                  <span>
                    定价：￥{{item.price}}
                  </span>
                </p>
                <p class="p-eBookPrice">
                  {{item.author}}
                  </p>
                <el-rate
                  class="star"
                  v-model="item.star"
                  disabled
                  show-score
                  text-color="#0066CC"
                  :score-template="'1155条评论'">
                </el-rate>
                <div class="d-describe">
                  {{item.describe}}
                </div>
                <p class="p-btns">
                  <button @click="trialReading">免费领取</button>
                  <img @click="collection(item.isSc, item.id, index)" :src="item.isSc ? star2 : star1" alt="">
                </p>
              </div>
            </li>
          </ul>
        </div> -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
import SidebarTwo from '@/base/sidebar2/sidebar2'
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'menu-list': Menu,
    'sidebar-two': SidebarTwo,
    'nav-menu': NavMenu
  },
  data () {
    return {
      activeIndex: '0',
      xmImg: require('@/assets/images/xm/xm.png'),
      gwc1: require('@/assets/images/fl/gwc1.png'),
      gwc2: require('@/assets/images/fl/gwc2.png'),
      star1: require('@/assets/images/fl/star1.png'),
      star2: require('@/assets/images/fl/star2.png'),
      navMenuList: [{
        text: '最新特价',
        pathName: 'Newest'
      }, {
        text: '免费专区',
        pathName: 'Free'
      }, {
        text: '重磅推荐',
        pathName: 'ZbRecommend'
      }, {
        text: '最新上架',
        pathName: 'NewUp'
      }],
      currentPage: 2,
      sidebarTwoTitle: '图书分类',
      sidebarTwoList: [],
      dataList: [{
        id: '3',
        imgUrl: require('@/assets/images/2.png'),
        name: '把话说到心窝里',
        money: '0.00',
        price: '46.00',
        eBookPrice: '6.00',
        author: '王阳明',
        star: 3,
        describe: '你看大家撒的撒而爱的撒旦',
        isGwc: false,
        isSc: true
      }, {
        id: '3',
        imgUrl: require('@/assets/images/2.png'),
        name: '把话说到心窝里',
        money: '0.00',
        price: '46.00',
        eBookPrice: '6.00',
        author: '王阳明',
        star: 3,
        describe: '你看大家撒的撒而爱的撒旦撒大菩萨模块的点点滴滴吃的撒倒萨大的点点滴滴吃的撒倒萨大',
        isGwc: false,
        isSc: true
      }]
    }
  },
  methods: {
    selectMenu (index) {
      this.activeIndex = '0'
      this.$router.push({
        name: 'Newest'
      })
    },
    handleSelect (key) {
      this.activeIndex = key
      const name = this.navMenuList[key].pathName
      this.$router.push({
        name: name
      })
    },
    collection (state, id, index) { // 收藏
      // console.log(state, id, index)
      this.dataList[index].isSc = !state
      this.$notify({
        title: '成功',
        message: state ? '已取消收藏' : '已成功收藏',
        type: state ? 'info' : 'success',
        showClose: false,
        duration: 1500
      })
    },
    trialReading () { // 在线试读
      alert('在线试读')
    },
    activePath () {
      const pathName = this.$route.name
      this.navMenuList.forEach((e, i) => {
        if (e.pathName === pathName) {
          this.activeIndex = i.toString()
        }
      })
    }
  },
  mounted () {
    this.activePath()
  }
}
</script>
<style lang="less" scoped>
  .personal-view{
    .menu{
      margin: 20px auto;
      width: 600px;
    }
    .content{
      display: flex;
      .left-nav{
        width: 200px;
      }
      .right-middle{
        flex: 1;
        margin-left: 20px;
        .xm{
          margin-top: 20px;
          border: 1px solid #A0998D;
          overflow: hidden;
          position: relative;
          padding: 30px 0 0 0;
          .xmImg{
            background: #990000;
            color: white;
            width: 150px;
            line-height: 30px;
            transform:rotate(-45deg);
            text-align: center;
            position: absolute;
            left: -50px;
            top: 10px;
            font-size: 14px;
          }
          .data-view{
            padding: 0;
            margin: 0;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            li{
              max-width: 50%;
              min-width: 50%;
              display: flex;
              padding-bottom: 30px;
              .left{
                padding-left: 60px;
                img{
                  width: 137px;
                  height: 196px;
                }
              }
              .right{
                padding-left: 15px;
                padding-right: 50px;
                flex: 1;
                font-size: 14px;
                p{
                  padding: 10px 0 0 0;
                  margin: 0;
                }
                .p-name{
                  color: #35353b;
                  font-size: 16px;
                  padding-top: 0;
                }
                .p-money{
                  color: #de0024;
                  font-weight: 600;
                  font-size: 16px;
                  span{
                    font-weight: 200;
                    text-decoration: line-through;
                    color: #A2A2A2;
                    font-size: 12px;
                  }
                }
                .p-eBookPrice{
                  color: #A2A2A2;
                }
                .star{
                  margin-top: 10px;
                }
                .d-describe{
                  margin-top: 10px;
                  overflow: hidden;
                  word-break: break-all;
                  display: -moz-box;
                  -moz-box-orient:vertical;
                  display: -webkit-box;
                  -webkit-box-orient:vertical;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 2;
                  height: 38px;
                }
                .p-btns{
                  vertical-align: middle;
                  button{
                    width: 100px;
                    height: 28px;
                    background-color: #B7151E;
                    color: white;
                    outline: none;
                    border: 0;
                    border-radius: 6px;
                    cursor: pointer;
                    float: left;
                  }
                  img{
                    padding: 0 10px;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
<style>



// WEBPACK FOOTER //
// src/components/SpecialOffer/specialoffer.vue


// WEBPACK FOOTER //
// src/components/SpecialOffer/specialoffer.vue